<template>
  <div class="header">
    <div class="top-header">
      <div class="max-w flex">
        <div class="logo">
          <router-link to="/"
            ><img src="@/assets/images/header/logo.png" alt="首页"
          /></router-link>
        </div>
        <div class="nav flex only-pc">
          <div v-for="(item, index) in nav" :key="'pc' + index" class="pc-navs">
            <router-link :to="item.path" class="pc-nav"
              >{{ item.name }}
            </router-link>
            <div class="children-nav tra" v-if="item.children">
              <router-link
                v-for="(iitem, iindex) in item.children"
                :key="'c' + iindex"
                :to="item.path + iitem.path"
                class="mob-nav"
                >{{ iitem.name }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="button flex only-mob">
          <div
            class="click search only-mob"
            @click="searchOpen = !searchOpen"
          ></div>
          <!-- <div class="click people"></div> -->
        </div>
      </div>
    </div>
    <div class="top-search tra" :class="searchOpen ? 'open' : ''">
      <!-- <div class="flex">
        <input
          type="text"
          v-model="key"
          placeholder="请输入搜索关键词"
          class="input-search"
          @keyup.enter="toSearch"
        />
        <input
          type="button"
          value="搜索"
          @click="toSearch"
          class="input-button"
        />
      </div> -->
      <div class="mob-nav only-mob">
        <div class="in">
          <div v-for="(item, index) in nav" :key="'m' + index" class="mob-navs">
            <router-link
              :to="item.path"
              @click.native="item.children ? '' : (searchOpen = false)"
              class=""
              >{{ item.name }}
            </router-link>
            <div class="children-nav" v-if="item.children">
              <router-link
                v-for="(iitem, iindex) in item.children"
                :key="'mc' + iindex"
                :to="item.path + iitem.path"
                @click.native="searchOpen = false"
                >{{ iitem.name }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumn } from "@/api/web";
export default {
  data() {
    return {
      nav: [],
      searchOpen: false,
      key: "",
      on: false,
    };
  },
  created() {
    getColumn().then((res) => {
      this.nav = res.data;
    });
  },
  methods: {
    toSearch() {
      console.log(this.key);
      this.searchOpen = false;
      this.key = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  z-index: 999;
  .top-header {
    background: url("~@/assets/images/header/bg.png") center no-repeat;
    background-size: cover;
    color: #fff;
    box-shadow: 0px 8px 6px rgba(0, 0, 0, 0.1);
    .logo {
      a {
        display: block;
        @media only screen and (max-width: 1200px) {
          padding: 10px 0;
          img {
            height: 40px;
          }
        }
      }
    }
    .nav {
      .pc-navs {
        position: relative;
        .pc-nav {
          color: #fff;
          line-height: 100px;
          width: 112px;
          text-align: center;
          display: block;
          position: relative;
          &:hover {
            color: #3d8aff;
            background: #cee2ff;
          }
        }
        .router-link-active {
          &::before {
            content: "";
            width: 100%;
            height: 3px;
            position: absolute;
            bottom: 0;
            background: #fff;
            left: 0;
          }
        }
        .children-nav {
          position: absolute;
          background: #fff;
          width: 100%;
          opacity: 0;
          visibility: hidden;
          .mob-nav {
            display: block;
            text-align: center;
            padding: 20px 10px;

            &:hover {
              background: #3571cc;
              color: #fff;
            }
          }
        }
        &:hover .children-nav {
          opacity: 1;
          visibility: visible;
        }
      }
    }
    .button {
      .click {
        width: 36px;
        height: 36px;
        border-radius: 100%;
        background: #3571cc center no-repeat;
        cursor: pointer;
        &:hover {
          background: #28569d center no-repeat;
        }
      }
      .search {
        background-image: url("~@/assets/images/header/search.svg") !important;
        @media only screen and (max-width: 1200px) {
          background-image: url("~@/assets/images/header/menu.svg") !important;
        }
      }
      .people {
        background-image: url("~@/assets/images/header/people.svg") !important;
        margin-left: 20px;
        @media only screen and (max-width: 1200px) {
          margin-left: 10px;
        }
      }
    }
  }
  .top-search {
    position: relative;
    background: #28569d;
    height: 0;
    overflow: hidden;
    .flex {
      justify-content: center;
      height: 100px;
      border-bottom: 1px solid #fff;
      @media only screen and (max-width: 1200px) {
        height: 60px;
      }
      input {
        border: none;
        outline: none;
        background: none;
        color: #fff;
        font-size: 20px;
      }
      input::-webkit-input-placeholder {
        color: #c9c9c9;
      }
      .input-search {
        text-align: center;
        margin-right: 20px;
      }
      .input-button {
        cursor: pointer;
      }
    }
    .mob-nav {
      height: calc(100vh - 62px - 61px);
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        display: block;
        text-align: center;
        color: #fff;
        padding: 10px 0;
        font-size: 20px;
        position: relative;
      }
      .router-link-active {
        &::after {
          content: "";
          position: absolute;
          width: 10px;
          height: 2px;
          background: #fff;
          top: 20px;
          margin-left: 10px;
        }
        &::before {
          content: "";
          position: absolute;
          width: 10px;
          height: 2px;
          background: #fff;
          top: 20px;
          margin-left: -24px;
        }
      }
    }
  }
  .open {
    height: 100px;
    @media only screen and (max-width: 1200px) {
      height: 100vh;
    }
  }
}
</style>
